
<template>
  <div class="game-tab-height">
      <div style="display:flex; flex-direction:row; cursor: pointer;">
        <div style="padding-right: 10px;" class="smf-display-none" @click="tabChange('left')"><i class="fa fa-angle-left"></i></div>
          <div id="hoge" style="overflow-x:scroll; display:flex; align-items:flex-start;">          
            <div  v-for="(game_detail, game_detail_index) in this.GameDetail" :key="game_detail[0]" class="display-inline">
              <span v-if="0 === game_detail_index">
                <div @click="change(game_detail[0], game_detail[1], game_detail_index)" v-bind:class="{'active': isActive === game_detail[0]}">
                  <h2 v-bind:class="{'under-line-red': isActive === game_detail[0]}" class="game-tab-font" style="white-space: nowrap; min-width: 40px; margin-left:10px; margin-right:10px; text-align: center; writing-mode: horizontal-tb;">
                    {{game_detail[0]}}
                  </h2>
                </div>
              </span>
              <span v-else>
                <div @click="change(game_detail[0], game_detail[1], game_detail_index)" v-bind:class="{'active': isActive === game_detail[0]}">
                  <h2 v-bind:class="{'under-line-red': isActive === game_detail[0]}" class="game-tab-font" style="white-space: nowrap;  padding-bottom:0; margin-left:10px; margin-right:10px; min-width: 40px; text-align: center; overflow: visible;">
                    {{game_detail[0]}}
                  </h2>
                </div>
              </span>
            </div>          
          </div>
        <div style="padding-left: 10px;" class="smf-display-none" @click="tabChange('right')"><i class="fa fa-angle-right"></i></div>
      </div>
      <div v-for="(game_detail) in GameDetail" :key="game_detail[0]" >
        <div v-if="isActive === game_detail[0]">
          <h4 class="profile-info-item__title">
            <i class="fas fa-chess-queen"></i>{{ isActive }}のスキルレベル
          </h4>
          <div v-for="(game_skill_detail,index) in game_detail[3]" :key="index" style="font-size: 14px;">
            {{game_skill_detail[0]}}:  {{game_skill_detail[1]}}
            
          </div>
          <h4 class="profile-info-item__title" style="margin-top: 6px">
            <i class="fas fa-gamepad"></i>{{ isActive }}のプロフィール
          </h4>
            <p class="game-tab-width">{{game_detail[2]}}</p>
        </div>
      </div>
  </div>
</template>


<script>
  import axios from 'packs/axios'

  export default {
    props: ['identifiedChar'],
    data: function () {
      return {
        isActive: '',
        isActiveGameSlug: '',
        GameDetail:'',
        isActiveTab:0,
      }
    },
    computed: {
    },
    methods: {
      fetchCurrentUser: function(){
        var self = this;
        axios.get("/api/v1/current_user")
        .then(function(res) {
        }).catch((err) => {   
          this.isLoading = false;                 
        })
      },
      fetchGameProfile: function(){
        var self = this;
        const element = document.getElementById("game-tab");
        const data = JSON.parse(element.getAttribute('data')); 
        
        console.log("test" + data.identifiedChar)
        axios.get("/api/v1/user_sale_games", {
          params: {
            identified: data.identifiedChar
          }
        })
        .then(function(res) {
          self.GameDetail = res.data.UserGameDetailAraay
         
          if(data.ReferrerGame){
            self.GameDetail.forEach((detail, index) => {
              if(detail[0] === data.ReferrerGame){                
                self.isActiveTab = index
                self.isActive = data.ReferrerGame
              }
            })
            
          }else{
            self.isActive = self.GameDetail[0][0]
            self.isActiveTab = 0
          }
        }).catch((err) => {   
          this.isLoading = false;                 
        })
      },
      get_recommend_host_by_game: function(title, slug){
        
        if(!document.querySelectorAll(".breadcrumbs a")[1]){
          const angle_elm = document.createElement('i');
          const game_elm = document.createElement('a');
          game_elm.setAttribute("href", `/games/${slug}`)
          angle_elm.className = "fas fa-angle-right";
          game_elm.textContent = title
          document.querySelector(".breadcrumbs a").after(angle_elm)
          document.querySelector(".breadcrumbs a").after(game_elm)
          document.querySelector(".breadcrumbs a").after(angle_elm)
        }

        document.querySelectorAll(".breadcrumbs a")[1].textContent =`${title}`
        document.getElementsByClassName("current")[0].textContent =`${gon.user_name}の${title}フレンド募集プロフィール`
        document.getElementById("get_recommend_host").setAttribute("href", `/api/v1/profiles/get_recommend_host_by_game?game=${slug}&identified_char=${gon.identified_char}`)
        document.getElementById("get_recommend_host").click()
      },
      change: function(title, slug, index){
        var target = document.getElementById('hoge');	      

        if(this.isActiveTab < index){
          target.scrollLeft += 50*(index - this.isActiveTab);
        }else if(this.isActiveTab > index){
          target.scrollLeft -= 50*(this.isActiveTab - index);
        }
        this.isActive         = title
        this.isActiveGameSlug = slug
        this.isActiveTab      = index

        const url = new URL(window.location);
			  history.replaceState('', 'title', url.pathname + "?game=" + this.isActiveGameSlug);
        this.get_recommend_host_by_game(this.isActive, this.isActiveGameSlug)
      },
      tabChange: function(direction){
        var target = document.getElementById('hoge');	      
        if(direction === "right"){
          target.scrollLeft += 50;
          if((this.GameDetail.length -1) <= this.isActiveTab){
            this.isActiveTab == this.GameDetail.length
            this.isActive = this.GameDetail[this.GameDetail.length -1][0]
            this.isActiveGameSlug = this.GameDetail[this.GameDetail.length -1][1]
          }else{
            this.isActiveTab += 1
            this.isActive = this.GameDetail[this.isActiveTab][0]
            this.isActiveGameSlug = this.GameDetail[this.isActiveTab][1]
          }
        }else{
          target.scrollLeft -= 50;
          if(this.isActiveTab === 0){
            this.isActiveTab == 0
            this.isActive = this.GameDetail[0][0]
            this.isActiveGameSlug = this.GameDetail[0][1]
          }else{
            this.isActiveTab -= 1
            this.isActive = this.GameDetail[this.isActiveTab][0]
            this.isActiveGameSlug = this.GameDetail[this.isActiveTab][1]
          }
        }
        const url = new URL(window.location);
			  history.replaceState('', 'title', url.pathname + "?game=" + this.isActiveGameSlug);
        this.get_recommend_host_by_game(this.isActive, this.isActiveGameSlug)
      }
    },
    created () {
      self = this
              console.log("test" + this.identifiedChar)

      this.fetchCurrentUser()
      this.fetchGameProfile()
    },
  }
</script>

<style scoped>
.display-inline{
  float: left;
}
.tab_list {
    overflow: hidden;
  }
.tab_list li {
  float: left;
  padding: 10px 20px;
  border: 1px solid #ccc;
  cursor: pointer;
  transition: .3s;
}
.tab_list li:not(:first-child) {
  border-left: none;
}
.tab_list li.active {
  background-color: #000;
  border-color: #000;
  color: #fff;
  cursor: auto;
}
.article{
  overflow: hidden;
  margin-top: -1px;
}
.article li {
  width: 320px;
  padding: 20px;
  border: 1px solid #ccc;
}
ul {
  color: #000;
  display: flex;
}
.game-margin{
  margin-left: 15px;
}

.border-bottom{
  border-bottom-color: rgb(204, 204, 204);
  border-bottom-style: solid;
  border-bottom-width: 1px;
}
.under-line-red{
  border-bottom-color:crimson;
  border-bottom-style: solid;
  border-bottom-width: 3px;
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
</style>
